// The heading of a column under the main list. Category names come from the DB.
export function ColumnTitle({ children }: { children: React.ReactNode }) {
  return (
    <div className="font-primary font-bold text-[44px] leading-none text-brand-jasper pb-[12px] border-b-[6px] border-brand-jasper mb-[4px]">
      {children}
    </div>
  )
}
